import { IonButtons, IonContent, IonHeader, IonItem, IonLabel, IonPage, IonTitle, IonToolbar 
,IonList, IonItemDivider, IonItemGroup
,IonIcon
} from '@ionic/react';
//import { useParams } from 'react-router';
import './WpDtl.css';
import { camera, trash, close,checkmarkDoneOutline, checkmarkCircle, qrCodeOutline, documentText, shieldCheckmarkOutline, clipboardOutline
  , chevronBackOutline , chevronForwardOutline, checkmarkDoneCircleOutline, calendar, personCircle, map, informationCircle, save
  } from 'ionicons/icons';
import OpenMenuButton from "../../../components/OpenMenuButton";
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import ServerService from '../../../services/Server';
import { useHistory } from 'react-router-dom';
import { setAuthPersisted } from '../../../services/pinUtils';
type WpFormParams = {
  id:string, 
  dummy:string
}
  const WpDtl: React.FC = () => {
  const {id, dummy} = useParams<WpFormParams>();
  const [docid, setDocId] = useState("");
  const [authorname, setAuthorname] = useState("");
  const [authorcompany, setAuthorcompany] = useState("");
  const [authoridcard, setAuthoridcard] = useState("");
  const [authorposition, setAuthorposition] = useState("");
  const [authortelephone, setAuthortelephone] = useState("");
  const [worklocation, setWorklocation] = useState("");
  const [workbuilding, setWorkbuilding] = useState("");
  const [workfloor, setWorkfloor] = useState("");
  const [workdate, setWorkdate] = useState("");
  const [worktime, setWorktime] = useState("");
  const [areaownertel, setAreaownertel] = useState("");
  const [workextendtime, setWorkextendtime] = useState("");
  const [workextendremark, setWorkextendremark] = useState("");
  const [requestwork, setRequestwork] = useState([]);
  const [projectdetail, setProjectdetail] = useState([]);
  const [projectname, setProjectname] = useState("");
  const [attach, setAttach] = useState([]);
  const [equipment, setEquipment] = useState([]);
  const [protection, setProtection] = useState([]);
  const [areaname, setAreaName] = useState("");
  const [worktimetype, setWorktimetype] = useState("");
  const [comment, setComment] = useState("");
  const server = new ServerService();
  const history = useHistory();
  server.setHistory(history);
  const data = {
    docid: id
  }
  useEffect(() => {
    fetchWp("");
  }, [])
  const fetchWp = function(status:any) {

    fetch(server.getFullUrl("wp/mb/getQcDoc", data),server.getRequest())
    .then(res => res.json()
    .then(
      (result) => {
        console.log('fetchWp');
        setDocId(result.docid);
        setAuthorname(result.authorname);
        setAuthorcompany(result.authorcompany);
        setAuthoridcard(result.authoridcard);
        setAuthorposition(result.authorposition);
        setAuthortelephone(result.authortelephone);
        setWorklocation(result.worklocation);
        setWorkbuilding(result.workbuilding);
        setWorkfloor(result.workfloor);
        setWorkdate(result.workdate);
        setWorktime(result.worktime);
        setAreaownertel(result.areaownertel);
        setWorkextendtime(result.workextendtime);
        setWorkextendremark(result.workextendremark);
        setRequestwork(result.requestworktype);
        setProjectdetail(result.projectdetail);
        setAttach(result.attach);
        setEquipment(result.equipment);
        setProtection(result.protection);
        setAreaName(result.areaname);
        setWorktimetype(result.worktimetype);

      },
      (error) => {
  
      }
   ).catch(e => {
  
   })
  ).catch(e => {
  
  })
   
  }
  const onBack = function() {
    setAuthPersisted();
    window.location.href = "/page/home/wp/wpIns/0/d";
  }
  return (
    <IonPage>
       <IonHeader>
        <IonToolbar>
        <IonButtons onClick={(e) => onBack()} slot="start">
          <IonIcon icon={chevronBackOutline}></IonIcon>
          </IonButtons>
          <IonTitle>Workpermit Details :  {id}</IonTitle>
        </IonToolbar>
      </IonHeader>    
        <IonContent>
        <IonList>     
      <IonItemGroup>
      <IonItemDivider color="light">
        <IonLabel>
            1. รายละเอียดผู้รับเหมา
        </IonLabel>
      </IonItemDivider>
      <IonItem>
        <IonLabel>  
            <h3>เลขที่</h3>
            <p>{docid}</p>      
        </IonLabel>
      </IonItem>
      <IonItem>
        <IonLabel>  
            <h3>ผู้ขออนุญาต</h3>
            <p>{authorname}</p>      
        </IonLabel>
      </IonItem>
      <IonItem>
        <IonLabel>  
            <h3>บริษัทผู้ขออนุญาต</h3>
            <p>{authorcompany}</p>      
        </IonLabel>
      </IonItem>
      <IonItem>
        <IonLabel>  
                <h3>เลขบัตรประชาชน/ID : {authoridcard}</h3>
                <h3>ตำแหน่ง : {authorposition}</h3>
                <h3>เบอร์ติดต่อ : {authortelephone}</h3>   
        </IonLabel>
      </IonItem>
      <IonItemDivider color="light">
        <IonLabel>
            2. สถานที่ปฏิบัติงาน
        </IonLabel>
      </IonItemDivider>
      <IonItem>
        <IonLabel>  
                <h3>พื้นที่ : {areaname}</h3>
                <h3>สถานที่ปฏิบัติงาน : {worklocation}</h3>
                <h3>อาคาร : {workbuilding} ชั้น : {workfloor}</h3>
                <h3>ทำงานวันที่ : {workdate} </h3>   
        </IonLabel>
      </IonItem>
      <IonItem>
        <IonLabel>  
                <h3>ชื่อเจ้าของพื้นที่ : {worklocation}</h3>
                <h3>เบอร์ติดต่อ : {areaownertel} </h3>   
        </IonLabel>
      </IonItem>
      <IonItemDivider color="light">
        <IonLabel>
          3. วันและเวลาที่ขออนุญาต
        </IonLabel>
      </IonItemDivider>
      <IonItem>
        <IonLabel>  
                <h3>เวลาทำการ : {worktimetype}</h3>
                <h3>ทำงานวันที่ : {workdate}</h3>
                <h3>ตั้งแต่เวลา : {worktime}</h3>
        </IonLabel>
      </IonItem>
      <IonItemDivider color="light">
        <IonLabel>
          ต่ออายุใบอนุญาต
        </IonLabel>
      </IonItemDivider>
      <IonItem>
        <IonLabel>  
              <h3>ตั้งแต่เวลา : {workextendtime}</h3>
              <h3>เหตุเนื่องจาก : {workextendremark}</h3>
        </IonLabel>
      </IonItem>
      <IonItemDivider color="light">
        <IonLabel>
           4. ประเภทงานที่ผู้รับเหมาขออนุญาตเข้าทำงาน (Type of work)
        </IonLabel>
      </IonItemDivider>
      {requestwork.map((work, index) => (
         <IonItem key={index}>
         <IonLabel>  
         <h3>{work}</h3>
         </IonLabel>
       </IonItem>
        ))}
      
      <IonItemDivider color="light">
        <IonLabel>
           5. ระบุชื่องาน/ Project ที่ทำ : {projectname}
        </IonLabel>
      </IonItemDivider>
      {projectdetail.map((pro, index) => (
         <IonItem key={index}>
         <IonLabel>  
         <h3>{pro}</h3>
         </IonLabel>
       </IonItem>
        ))}
      <IonItemDivider color="light">
        <IonLabel>
         6. เอกสารแนบ วิธีปฏิบัติงาน และใบรับรอง (Method Statement & Catificates)
        </IonLabel>
      </IonItemDivider>
      {attach.map((att, index) => (
         <IonItem key={index}>
         <IonLabel>  
         <h3>{att}</h3>
         </IonLabel>
       </IonItem>
        ))}
      <IonItemDivider color="light">
        <IonLabel>
         7. อุปกรณ์ป้องกันอันตรายส่วนบุคคล (PPE) ที่ผู้รับเหมาต้องสวมใส่มีดังนี้
        </IonLabel>
      </IonItemDivider>
      {equipment.map((pro, index) => (
         <IonItem key={index}>
         <IonLabel>  
         <h3>{pro}</h3>
         </IonLabel>
       </IonItem>
        ))}
      <IonItemDivider color="light">
        <IonLabel>
        8. อุปกรณ์ป้องกันอันตราย (Work Place Safety Precaution)
        </IonLabel>
      </IonItemDivider>
      {protection.map((pro, index) => (
         <IonItem key={index}>
         <IonLabel>  
         <h3>{pro}</h3>
         </IonLabel>
       </IonItem>
        ))}
    </IonItemGroup>
     
      </IonList>
      </IonContent>
    </IonPage>
  );
};

export default WpDtl;
